<template>
  <div class="custom-navbar d-flex align-items-center justify-content-between px-3 px-md-5">
    <!-- Left: Brand / Logo -->
    <div class="d-flex align-items-center">
      <!-- Loading State -->
      <div
        v-if="loading"
        class="spinner-border spinner-border-sm text-danger mr-2"
        role="status"
      >
        <span class="sr-only">Loading...</span>
      </div>

      <!-- Loaded Brand Info -->
      <div
        v-else
        class="d-flex align-items-center"
      >
        <b-img
          :src="business.company_logo ? `${bucketUrl}${business.company_logo}` : defaultCompanyLogo"
          alt="logo"
          class="brand-logo mr-1"
        />
        <span class="brand-title">
          {{ business.company_name || '' }}
        </span>
      </div>
    </div>

    <!-- Right: Home Action Button -->
    <b-navbar-nav class="align-items-center ml-auto">
      <a
        href="/"
        class="home-btn"
        aria-label="Home"
      >
        <feather-icon
          icon="HomeIcon"
          size="26"
          class="home-icon"
        />
      </a>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BImg,
  BNavbarNav,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { bucketUrl, defaultCompanyLogo } from '@/constants/config'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const trackingRepository = RepositoryFactory.get('tracking')

export default {
  directives: {
    Ripple,
  },
  components: {
    BImg,
    BNavbarNav,
  },
  mixins: [ErrorMessage],
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      bucketUrl,
      defaultCompanyLogo,
      business: {},
      loading: false,
    }
  },
  mounted() {
    this.getBusinessInfo()
  },
  methods: {
    async getBusinessInfo() {
      try {
        this.loading = true
        const response = await trackingRepository.getBusinessInfo()
        if (response.status === 200) {
          this.business = response.data.data
          localStorage.setItem('businessSettings', JSON.stringify(this.business))
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.custom-navbar {
  background-color: #ffffff;
  border-bottom: 1px solid #edf0f2;
  position: relative;
  z-index: 100;
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
}

.brand-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.brand-title {
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: -0.5px;
  color: #1a202c;
  margin-left: 0.25rem;
}

.home-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-decoration: none;
}

.home-btn:hover {
  background-color: #fce8eb;
}

.home-icon {
  stroke: #a30014 !important;
  color: #a30014 !important;
}

@media (max-width: 576px) {
  .custom-navbar {
    height: 60px;
  }

  .brand-title {
    font-size: 1.2rem;
  }

  .brand-logo {
    width: 28px;
    height: 28px;
  }

  .home-btn {
    width: 36px;
    height: 36px;
  }
}
</style>
